exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../../../../res/img/svg/open-in-new.svg"));

// Module
exports.push([module.id, ".menuButtons{display:flex;height:100%;flex-flow:row nowrap}.menuButtonsLink{position:relative;height:24px;padding:0 20px;border-left:1px solid var(--grey-30);color:var(--grey-90);cursor:default;line-height:24px;text-decoration:none}.menuButtonsLink:hover{background-color:rgba(0,0,0,.1)}.open-in-new{padding:10px;background-image:url(" + ___CSS_LOADER_URL___0___ + ");background-position:50%;background-repeat:no-repeat;background-size:11px}", ""]);

